export interface ContentCardProps {
    uuid: string;
    type: keyof typeof ContentType;
    imageUrl: string;
    description?: string;
    score?: number;
    name: string;
    displayName: string;
    tags?: string[];
    timeOrDate?: string;
    menuActions?: { iconName: string; text: string; onClick: Function }[];
    cardUrl?: string;
    useOverlay?: boolean;
    language?: string;
    onClick?: Function;
    tagline?: string;
    count?: number;
    onCompletionCertificateClick?: Function;
    isLeanDisabled?: boolean;
    points?: number;
    earnedPoints?: number;
    doneRecently?: boolean;
    onContactUsClick?: Function;
    status: 'inProgress' | 'completed' | 'notStarted';
    month?: string;
    dueDate?: Date;
    disabled?: boolean;
    hasCertificate?: boolean;
    pointer?: boolean;
    isCourseCreationPreview?: boolean;
    isTaken?: boolean;
    maxScore?: number;
    level?: string;
    challengeUrl?: string;
    links?: Tag[];
    tagsNames?: string[];
    systemCourseDisplayName?: string;
    customCourseDisplayNames?: string;
}

export enum ContentType {
    lesson,
    course,
    challenge,
    assessment,
    tournament,
    videoTutorial,
    skillTree,
    learningPath,
    lab
}

export interface Tag {
    tag: string;
    url: string;
}
